export default {
  // Set integrations loaded state to true
  integrationTimestamp(state) {
    state.integrationTimestamp = String(
      Math.round(new Date().getTime() / 1000)
    );
  },
  // Set integrations
  integrations(state, payload) {
    state.integrations = payload;
  },
  // Set features
  features(state, payload) {
    state.features = payload;
  },
  // Set carriers
  carriers(state, payload) {
    state.carriers = payload;
  },
};
